import {Button, ButtonGroup, closeCurrentDialog, IconButton} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

export function RepublishInfoDialogContent() {
  return (
    <>
      <VStack align="flex-end">
        <IconButton
          data-testid="republishInfoDialog"
          icon="navigation/close"
          onClick={closeCurrentDialog}
        />
      </VStack>
      <VStack spacing={1}>
        <Text>{i18n.t('entity.watermark.republishDialogInfo.description')}</Text>
      </VStack>
      <ButtonGroup align="right">
        <Button
          data-testid="republishAds-dialog-confirm"
          variant="primary"
          onClick={closeCurrentDialog}
          title={i18n.t('general.actions.confirm')}
        />
      </ButtonGroup>
    </>
  );
}
